export const AUTH_INPUT_CLASS =
  'h-12 rounded-sm border-st2 bg-background px-3 py-2 font-inter text-p-400 tracking-normal placeholder:text-tertiary focus-visible:border-brand focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-brand/30 disabled:bg-bg2'

export const AUTH_PRIMARY_BUTTON_CLASS =
  'w-full rounded-sm bg-brand text-brand-foreground hover:bg-brand/90 disabled:bg-st1 disabled:text-secondary disabled:opacity-100'

export const AUTH_LINK_CLASS =
  'font-inter text-brand-text no-underline underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-brand'
